/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-08-03, 10:19:58
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-26, 10:45:29
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

import Vue from 'vue';
import store from '@/store';
import { mapActions, mapGetters } from 'vuex';

// COMPONENTS //////////////////////////////////////////////////////////////////
import ComplainsForm from '@/components/Complains/ComplainsForm';
import Tile from '@/components/Common/TheTile';

// CONTAINER ///////////////////////////////////////////////////////////////////
const OccasionZone = {
  components: {
    ComplainsForm,
    Tile,
  },
  data() {
    return {
      clickedTile: '',
    };
  },
  store,
  computed: {
    ...mapGetters(['subscriber', 'settings', 'complainsFormHasBeenSent', 'mainComponentsVisibility', 'pendingStoreActions', 'occasionZoneTilesContents', 'occasionZoneFormSettings']),
  },
  methods: {
    ...mapActions(['getOccasionZoneTilesContents', 'getOccasionZoneFormSettings', 'setClickedTileName']),
    setCategory(category) {
      this.clickedTile = category;
    },
  },

  created() {
    this.getOccasionZoneTilesContents();
    this.getOccasionZoneFormSettings();
  },

  template: `
   <div class="container-fluid animated fadeIn">
   <div class="row">
     <div class="col-xs-12">
       <h1 class="text-center">Strefa Okazji</h1>
     </div>
   </div>
   <div class="row">
     <div style="display: flex; flex-wrap: wrap; justify-content: space-evenly; margin: 20px 0;">
        <Tile v-for="tile in occasionZoneTilesContents"
          :key="tile.uuid"
          :header="tile.header_content"
          :paragraph="tile.paragraph_content"
          :image="tile.image"
          :order="tile.order"
          :image-first="tile.is_image_first"
          :full-height-image="tile.full_height_image"
          :image-to-bottom="tile.image_to_bottom"
          :is-additional-tab-visible="tile.is_additional_tab_visible"
          :additional-tab-content="tile.additional_tab_content"
          :category="tile.category_id"
          @select-category="setCategory"
         />
     </div>
   </div>
   <div class="row">
    <complains-form
    :settings="occasionZoneFormSettings"
    :subscriber="subscriber"
    :complains-form-has-been-sent="complainsFormHasBeenSent"
    :is-loading-data="pendingStoreActions.includes('sendComplainsForm')"
    :move-to-category="clickedTile"
    :form-name="'occasionZone'"
    />
   </div>
 </div>
   `,
};

export default Vue
  .component('OccasionZone', OccasionZone);




// WEBPACK FOOTER //
// ./src/containers/OccasionZone/index.js